import { Typography } from 'src/components/PulseUI';
import { formatPhoneNumber } from 'src/utils/formatPhoneNumber/formatPhoneNumber';

const PhoneCell = ({ row }) => {
  const formattedNumber = row.phone
    ? formatPhoneNumber(row.phone)
    : row.provider?.phone
    ? formatPhoneNumber(row.provider.phone)
    : '';

  if (!formattedNumber) return null;

  return <Typography variant="body2">{formattedNumber}</Typography>;
};

export default PhoneCell;
